import { render, staticRenderFns } from "./PaymentSummary.vue?vue&type=template&id=5989ef8b&scoped=true"
import script from "./PaymentSummary.vue?vue&type=script&lang=js"
export * from "./PaymentSummary.vue?vue&type=script&lang=js"
import style0 from "./PaymentSummary.vue?vue&type=style&index=0&id=5989ef8b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989ef8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5989ef8b')) {
      api.createRecord('5989ef8b', component.options)
    } else {
      api.reload('5989ef8b', component.options)
    }
    module.hot.accept("./PaymentSummary.vue?vue&type=template&id=5989ef8b&scoped=true", function () {
      api.rerender('5989ef8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/PaymentSummary.vue"
export default component.exports